import React from 'react';
import EditPencil from '../../assets/EditPencil';
import MoveIcon from '../../assets/MoveIcon';
import ReorderIcon from '../../assets/ReorderIcon';
import DeleteMenuIcon from '../../assets/DeleteMenuIcon';

export const types = [
  { name: 'ROCKED', value: 'ROCKED' },
  { name: 'OEM', value: 'OEM' },
  { name: 'PARTNER', value: 'PARTNER' },
];
export const collectionList = [
  {
    id: 1,
    thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTmxFIJ9YKA4-P-oqN_th0SwXway_MHQkizw&s',
    title: 'Dealership 1',
    subTitle: 'SubTitle for Dealership 1',
    width: '492px',
    height: '72px',
    status: 1,
  },
  {
    id: 2,
    thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTmxFIJ9YKA4-P-oqN_th0SwXway_MHQkizw&s',
    title: 'Dealership 2',
    subTitle: 'SubTitle for Dealership 2',
    width: '492px',
    height: '72px',
    status: 0,
  },
  {
    id: 3,
    thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTmxFIJ9YKA4-P-oqN_th0SwXway_MHQkizw&s',
    title: 'Dealership 3',
    subTitle: 'SubTitle for Dealership 3',
    width: '492px',
    height: '72px',
    status: 1,
  },
  {
    id: 4,
    thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTmxFIJ9YKA4-P-oqN_th0SwXway_MHQkizw&s',
    title: 'Dealership 4',
    subTitle: 'SubTitle for Dealership 4',
    width: '492px',
    height: '72px',
    status: 0,
  },
  {
    id: 1,
    thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTmxFIJ9YKA4-P-oqN_th0SwXway_MHQkizw&s',
    title: 'Dealership 1',
    subTitle: 'SubTitle for Dealership 1',
    width: '492px',
    height: '72px',
    status: 1,
  },
  {
    id: 2,
    thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTmxFIJ9YKA4-P-oqN_th0SwXway_MHQkizw&s',
    title: 'Dealership 2',
    subTitle: 'SubTitle for Dealership 2',
    width: '492px',
    height: '72px',
    status: 0,
  },
  {
    id: 3,
    thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTmxFIJ9YKA4-P-oqN_th0SwXway_MHQkizw&s',
    title: 'Dealership 3',
    subTitle: 'SubTitle for Dealership 3',
    width: '492px',
    height: '72px',
    status: 1,
  },
  {
    id: 4,
    thumbnail: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTmxFIJ9YKA4-P-oqN_th0SwXway_MHQkizw&s',
    title: 'Dealership 4',
    subTitle: 'SubTitle for Dealership 4',
    width: '492px',
    height: '72px',
    status: 0,
  },
];

export const categoryMenuList = [
  {
    name: 'Edit Category',
    icon: <EditPencil fontSize="small" color="#667085" />,
  },
  {
    name: 'Reorder Categories',
    icon: <MoveIcon fontSize="small" />,
  },
  {
    name: 'Reorder Collections',
    icon: <ReorderIcon fontSize="small" />,
  },
  {
    name: 'Delete Category',
    icon: <DeleteMenuIcon fontSize="small" />,
  },
];
export const categoryCollectionMenuList = [
  {
    name: 'Remove Collection',
    icon: <DeleteMenuIcon fontSize="small" />,
  },
];
export const categoryEditCollectionMenuList = [
  {
    name: 'Edit Collection',
    icon: <EditPencil fontSize="small" />,
  },
];
